import { h } from "preact";
import { useEffect } from "preact/hooks";
import { CloseIcon } from "./icons.jsx";

export default function ReactModal({ children, open, setOpen }) {
  useEffect(() => {
    document.documentElement.classList[open ? "add" : "remove"](
      "overflow-hidden"
    );
    document.body.classList[open ? "add" : "remove"]("overflow-hidden");
  }, [open]);

  const handleCloseClick = () => setOpen(false);

  if (!open) return null;

  return (
    <div className={`modal modal--react overlay ${open ? "show-modal" : ""}`}>
      <div className="modal__overlay" onClick={handleCloseClick}></div>
      <div className="modal__content">
        <button
          className="modal__btn-close"
          aria-label="Close"
          onClick={handleCloseClick}
        >
          <CloseIcon />
        </button>
        <div className="modal__content__inner">{children}</div>
      </div>
    </div>
  );
}
